/**  @jsxImportSource @emotion/react */

const BlackFilter = () => {
  return (
    <div className="blackFilterView"></div>
  );
};
export default BlackFilter;
